import {ViewMode} from './view-mode'

export type CommentsDisplayMode = 'review-threads' | 'conversation'

/**
 * The "view mode" is user-facing, and encodes default filter and sort state in addition to how the comments are
 * actually displayed.
 *
 * The display mode is derived from the view mode but only controls how comments are displayed:
 *
 *  - `conversation`: Shows issue comments and review summaries in a conversation list, with review threads displayed
 *    only inside of review summary containers.
 *  - `review-threads`: Shows only review threads as a flat list with no grouping, omitting issue comments and review
 *    summaries.
 */
export const displayModeForViewMode = (viewMode: ViewMode) =>
  viewMode === ViewMode.IssueComments ? 'conversation' : 'review-threads'
